"use client";
// Imports
import {
  Drawer as ShadDrawer,
  DrawerClose,
  DrawerContent,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { Menu } from "lucide-react";

export function MobileNavDrawer({ children, direction = "bottom" }) {
  return (
    <ShadDrawer direction={direction} shouldScaleBackground={false}>
      <DrawerTrigger className="3xl:hidden focus:outline-none">
        <Menu />
      </DrawerTrigger>
      <DrawerContent className="p-4 bg-brand-wool focus:outline-none">
        {children}
      </DrawerContent>
    </ShadDrawer>
  );
}
